export default "__VITE_ASSET__Mr6A5F8j__"